import FormErrors from "@/components/FormErrors/FormErrors";
import { format } from "date-fns";
import { JSConn } from "@/utilities/js-conn";
import { map as Rmap } from "ramda";

// Some of this code is similar to the code that is in the office workers
// finish work order task form.
// This may be considered duplication, or it may be helpful because they
// are two different use cases.
// The data is loaded differently, in the case of the other form,
// it is pulled from the api when the form is mounted.
// since this form is used on a page that already has the data loaded,
// the data is not being reloaded from the api, it is just pulled from the store

export default {
  name: "fwFinishWorkOrderTaskForm",
  props: {
    workOrderTaskId: String,
  },
  components: {
    FormErrors,
  },
  data() {
    return {
      hasFormErrors: false,
      formErrors: [],
      workOrderTask: {},
      lineItems: [],
    };
  },
  created() {
    this.workOrderTask = {
      ...this.apiWorkOrderTask,
    };

    // set some of the data
    // since this form is being loaded, assume the task is finished
    // and that it was finished today.
    const td = format(new Date(), "yyyy-MM-dd");
    if (this.workOrderTask.start_date === null) {
      this.workOrderTask.start_date = td;
    }

    if (this.workOrderTask.completed_date === null) {
      this.workOrderTask.completed_date = td;
    }

    this.workOrderTask.status = "completed";

    // get the line items in a good state to save or edit them.
    this.lineItems = [...this.apiLineItems];
  },
  computed: {
    apiWorkOrderTask: function() {
      return this.$store.getters.workOrderTaskById(this.workOrderTaskId);
    },
    apiLineItems: function() {
      return this.apiWorkOrderTask.work_order_task_line_items;
    },
  },
  methods: {
    submitData: function(evt) {
      evt.preventDefault();

      const jsConnWorkOrderTask = new JSConn();

      jsConnWorkOrderTask.formParams = {
        id: this.workOrderTask.id,
        status: this.workOrderTask.status,
        start_date: this.workOrderTask.start_date,
        completed_date: this.workOrderTask.completed_date,
      };

      let jsConnTaskLineItems = Rmap(item => {
        const tempJsConn = new JSConn();
        tempJsConn.formParams = {
          id: item.id,
          quantity: item.quantity,
          item_date: this.workOrderTask.completed_date,
        };
        return this.$store.dispatch("updateWorkOrderTaskLineItem", tempJsConn);
      }, this.lineItems);

      const dataPromises = [
        this.$store.dispatch("completeWorkOrderTask", jsConnWorkOrderTask),
        ...jsConnTaskLineItems,
      ];

      Promise.all(dataPromises)
        .then(() => {
          this.$router.push({
            name: "fwWorkOrderTaskShow",
            params: {
              workOrderId: this.workOrderTask.work_order_id,
              workOrderTaskId: this.workOrderTaskId,
            },
          });
          // tell the parent that the data has changed
          this.$emit("tasksChanged");
          return Promise.resolve();
        })
        .catch(() => {
          // probably need to show the errors here, if there were some
          return Promise.reject();
        });
    },
  },
};
